<template>
  <app-content>
    <h1>{{ $t('nav.settings') }}</h1>
    <div class="card" v-if="user.data">
      <AppSetting name="Sprog"><InputSelect :options="[
          { display: 'Dansk', value: 'da' },
          { display: 'English', value: 'en' }
        ]"
        v-model="user.data.settings.lang" @select="save()" />
      </AppSetting>

      <AppSetting name="Enheder"><InputSelect :options="[
          { display: 'Metrisk', value: 'metric' },
          { display: 'Imperial', value: 'imperial' }
        ]"
        v-model="user.data.settings.units" @select="save()" />
      </AppSetting>

      <AppSetting v-if="false" name="Tema"><InputSelectHorizontal :options="[
          { display: 'Mørkt', value: 'dark' },
          { display: 'Lyst', value: 'light' }
        ]"
        v-model="user.data.settings.theme" @select="save()" />
      </AppSetting>
    </div>
  </app-content>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { store } from '@/store'
import AppSetting from '@/components/settings/AppSetting.vue'
import InputSelect from '@/components/inputs/InputSelect.vue'
import InputSelectHorizontal from '@/components/inputs/InputSelectHorizontal.vue'

export default defineComponent({
  name: 'UserSettings',
  components: { AppSetting, InputSelect, InputSelectHorizontal },
  setup() {
    
    const user = store.user.get(state => state.user)
    const settings = user.value ? user.value.settings : null

    async function save() {
      settings && await store.user.updateSettings(settings)
    }

    return { user, settings, save }
  }
})
</script>

<style lang="scss" scoped>
.setting {
  margin: 1rem 0;
  justify-content: space-between;
  align-items: center;
  display: flex;
  h4 {
    margin: 0;
  }
}
</style>